<template>
    <div class="dia-border grey" style="margin-top:20px">
        <div class="title-left  u-row-between u-flex mw">
            <div class="u-flex" >
                 <div class="head-title-lable">
                    <!-- <span class="red">*</span> -->
                    分段标题</div>
                 <Input  maxlength="50" v-model="value" placeholder="请输入" style="width: 280px"></Input>
            </div>
          <div  class="de-com" @click="remove" >
            <img src="@/assets/images/del.png" width="18px" height="18px" />
          </div>
         
        </div>
         <div class="dia-line"></div>
          <DiaChat 
          :typeobj="typeobj"
          :option="item.option" 
           @getoption="setDiaCur" :index="index" :char="diatice.char" 
           :oilSiteModelVOList="diatice.oilSiteModelVOList"
           :type="type"
            />
    </div>
</template>

<script>
 import DiaChat from './dia-chat'
  import debounce  from '@/util/debounce'
export default {
    props:["diatice","index","item","type","typeobj"],
    components:{
        DiaChat
    },
    data(){
        return {
         value:"",
         Option:"",
         charindex:0
        }
    },
    watch:{
      value:function(){
          this.charindex++
          if(this.charindex==1) return
         debounce(()=>{
               this.$emit("setData",{
                type:"char",
                option:this.Option,
                index:this.index,
                title:this.value
            })
          },true)
      },  
    },
    created(){
        this.init()
    },
    methods:{
        init(){
            this.value=this.item.title
         
        },
        remove(){
            this.$emit("remove",this.index)
        },
        setDiaCur(Option){
            this.Option=Option
        
            this.$emit("setData",{
                type:"char",
                option:Option,
                index:this.index,
                title:this.value
            })
        }
    }
}
</script>
<style scoped>
.red{
    color: red;
}
</style>